// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AppEnvironmentService } from '../app-environment.service';


@Injectable({providedIn: 'root'})
export class ParamterStoreService {

    constructor(private http: HttpClient, public router: Router, private envService: AppEnvironmentService) {

    }


    getAvailableNeoSimitVersions(): Observable<string[]> {
        const appConfig = this.envService.appEnvData;
        let accessToken = localStorage.getItem('access_token')

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        })

        const httpOptions = {
            headers: headers
        }

        const getParamterFilesURL = `${appConfig.baseApiUrl}parameterStoreFiles`
        //@ts-ignore
        return this.http.get<string[]>(getParamterFilesURL, httpOptions).pipe(map((response: any) => {
            if (response.body) {
                try {
                    let versions = response.body.split(',');
                
                    return versions;
                } catch (e) {
                    return [];
                }
            } else {
                return [];
            }
        }));

    }
}


export interface ParamterStoreContent {
    statusCode: string,
    body: string
}
